/**
 * Portfolios API (investment thesis groupings)
 */
import { apiClient } from './client'
import type { Portfolio, PortfolioCreate, PortfolioUpdate, Holding } from '../types'

const BASE_PATH = '/api/portfolios'

export const portfoliosApi = {
  list: async (): Promise<Portfolio[]> => {
    const response = await apiClient.get<Portfolio[]>(BASE_PATH)
    return response.data
  },

  get: async (portfolioId: string): Promise<Portfolio> => {
    const response = await apiClient.get<Portfolio>(`${BASE_PATH}/${portfolioId}`)
    return response.data
  },

  create: async (data: PortfolioCreate): Promise<Portfolio> => {
    const response = await apiClient.post<Portfolio>(BASE_PATH, data)
    return response.data
  },

  update: async (portfolioId: string, data: PortfolioUpdate): Promise<Portfolio> => {
    const response = await apiClient.put<Portfolio>(`${BASE_PATH}/${portfolioId}`, data)
    return response.data
  },

  delete: async (portfolioId: string): Promise<void> => {
    await apiClient.delete(`${BASE_PATH}/${portfolioId}`)
  },

  getHoldings: async (portfolioId: string): Promise<Holding[]> => {
    const response = await apiClient.get<Holding[]>(`${BASE_PATH}/${portfolioId}/holdings`)
    return response.data
  },
}
